import { Controller } from "@hotwired/stimulus"

// Starts the property import job only after turbo-cable-stream-source is connected
// (Solid Cable has no backlog for late subscribers — no Job.set(wait:)).
export default class extends Controller {
  static values = {
    url: String,
    started: { type: Boolean, default: false }
  }

  connect() {
    this.startWhenReady()
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
    if (this._fallbackTimer) clearTimeout(this._fallbackTimer)
  }

  startWhenReady() {
    const source = this.element.querySelector("turbo-cable-stream-source")
    if (!source) {
      this.enqueue()
      return
    }

    if (this.isConnected(source)) {
      this.enqueue()
      return
    }

    this._observer = new MutationObserver(() => {
      if (this.isConnected(source)) {
        this._observer.disconnect()
        this.enqueue()
      }
    })
    this._observer.observe(source, { attributes: true, attributeFilter: ["connected"] })

    // Safety net if the attribute never flips (should be rare).
    this._fallbackTimer = setTimeout(() => this.enqueue(), 10_000)
  }

  isConnected(source) {
    return source.hasAttribute("connected") || source.connected === true
  }

  async enqueue() {
    if (this.startedValue || !this.hasUrlValue || !this.urlValue) return
    this.startedValue = true
    if (this._observer) this._observer.disconnect()
    if (this._fallbackTimer) clearTimeout(this._fallbackTimer)

    const token = document.querySelector("meta[name='csrf-token']")?.content
    try {
      await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "text/vnd.turbo-stream.html, text/html",
          "X-CSRF-Token": token || "",
          "X-Requested-With": "XMLHttpRequest"
        },
        credentials: "same-origin"
      })
    } catch (e) {
      console.error("[import-cable-start] failed to start import", e)
    }
  }
}
